import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import warningSign from '../../../../../assets/warning-sign.svg';
import { CONTACT_SUPPORT_URL } from '../../../../../config/constants';
import { PocViewConstructor } from '../PocViewConstructor/PocViewConstructor';

import styles from './FatalError.module.scss';

export function FatalError(props: { onClose: VoidFunction }) {
  const { t } = useTranslation();

  return (
    <PocViewConstructor
      content={
        <>
          <p className={styles.accent}>
            {t('poc.cardVerificationWentWrongPrefix')}
            <span className={styles.extraAccent}>{t('errors.wentWrong')}</span>
            {t('poc.cardVerificationWentWrongSuffix')}
          </p>
          <img alt="warning sign" className={styles.warningSign} src={warningSign} />
          <p>{t('poc.weAreHereToHelp')}</p>
          <a
            className={classNames('button-action support-button animation-popup', styles.contactSupportButton)}
            href={CONTACT_SUPPORT_URL}
            rel="noreferrer"
            target="_blank"
          >
            {t('common.contactSupportFirstLetterUpper')}
          </a>
        </>
      }
      title={t('dialogs.oopsUpperFirstLetter')}
      onClose={props.onClose}
    />
  );
}
